module.exports = __webpack_public_path__ + "img/login-cutuglagua.3dd0e803.svg";